import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {  message,Checkbox,Button,Menu, Dropdown,Timeline ,Popover,Collapse,Select,DatePicker,Modal,Input  } from 'antd';
import {getData} from '../../../../services/index';
import {  QrcodeOutlined,PlusOutlined,DownOutlined,CheckOutlined,DeleteOutlined,RetweetOutlined,FieldTimeOutlined, EyeOutlined,SafetyCertificateOutlined,EditOutlined,MoreOutlined,PrinterOutlined,FileExcelOutlined,MessageOutlined,DownloadOutlined,MailOutlined,ImportOutlined,ExportOutlined } from '@ant-design/icons';

const CheckboxGroup = Checkbox.Group;

const { TextArea } = Input;
const { Panel } = Collapse;
const { Option } = Select;
function callback(key) {
  console.log(key);
}



class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			user_id:'',
			school_id:'',
			academic_year : '',
			fees_package_id: '',
			receipt_id:'0',
			package_list:[],
			category_list:[],
			installment_count:'',
			installment_list:[],
			fees_data_list:[],
			instl_1:0,
			instl_2:0,
			instl_3:0,
			instl_4:0,
			instl_5:0,
			instl_6:0,
			instl_7:0,
			instl_8:0,
			instl_9:0,
			instl_10:0,
			instl_11:0,
			instl_12:0,
			concession:0
		}
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		this.setState({ user_id : storedArray['data'][0]['user_id'] });
		
		}
		this.checkData();
	}
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var school_id = storedArray['data'][0]['school_id'];
			var user_id = storedArray['data'][0]['user_id'];
			
			var app = {school_id : school_id,user_id:user_id}
			getData('fees/print_setting',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							receipt_to_print: result['data'],
						});
					}else{
						this.setState({
							receipt_to_print: '',
						});
					}
				}
			});
			
	}
   }
   
	change_year=(event)=>{
         this.setState({academic_year: event});
		 var storedArray = JSON.parse(localStorage.getItem("schoolData"));
		 var school_id = storedArray['data'][0]['school_id'];
		 var user_id = storedArray['data'][0]['user_id'];
		
		 var app = {school_id : school_id,user_id:user_id,type:'Mandatory',academic_year:event}
		 getData('fees/fees_package_list',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
					this.setState({
						package_list: result['data'],
					});
				}else{
					this.setState({
						package_list: []
					});
				}
			}
		});
     }
	 
	 change_fees=(event)=>{
         this.setState({fees_package_id: event});
		 var storedArray = JSON.parse(localStorage.getItem("schoolData"));
		 var school_id = storedArray['data'][0]['school_id'];
		 var user_id = storedArray['data'][0]['user_id'];
		
		 var app = {school_id : school_id,user_id:user_id,type:'Mandatory',fees_package_id:event}
		 getData('fees/fees_category_list',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
					this.setState({
						category_list: result['data'],
					});
				}else{
					this.setState({
						category_list: []
					});
				}
			}
		});
     }
	 
	 change_installment=(event)=>{
         this.setState({installment_count: event});
		 const installment=[];
		 var sr=1;
		 for(var i=0;i<event;i++){
			 var app = {
				fees_package_id: this.state.fees_package_id,
				sr_no: sr
			}
			installment.push(app);
			sr++;
		 }
		 setTimeout(() => {
			this.setState({installment_list:installment});
		 }, 500);
		 
		 //get data
			var storedArray = JSON.parse(localStorage.getItem("schoolData"))
			var app = {
				school_id : storedArray['data'][0]['school_id'],
				user_id : storedArray['data'][0]['user_id'],
				academic_year : this.state.academic_year,
				type:'Optional',
				fees_package_id:this.state.fees_package_id,
		
			}
			getData('fees/get_fees_installment', app).then((result) => {
				let responseJson = result;
				if (responseJson.data) {
					if (result['status'] == 200) {
						this.setState({
							fees_data_list: result['data'],
							instl_1: result['data'][0]['instl_1'],
							instl_2:result['data'][0]['instl_2'],
							instl_3:result['data'][0]['instl_3'],
							instl_4:result['data'][0]['instl_4'],
							instl_5:result['data'][0]['instl_5'],
							instl_6:result['data'][0]['instl_6'],
							instl_7:result['data'][0]['instl_7'],
							instl_8:result['data'][0]['instl_8'],
							instl_9:result['data'][0]['instl_9'],
							instl_10:result['data'][0]['instl_10'],
							instl_11:result['data'][0]['instl_11'],
							instl_12:result['data'][0]['instl_12'],
							concession:result['data'][0]['concession']
						});
						
						
						setTimeout(() => {
							var instl_count = this.state.installment_count;
							var category = this.state.category_list;
										
							for (var i = 0; i < category.length; i++) {
							 for (var j = 1; j <=instl_count; j++) {
							 	if(document.getElementById('instl_'+i+'_'+j)){
									document.getElementById('instl_'+i+'_'+j).value=result['data'][i]['instl_'+j];
								}
								document.getElementById('concession_'+i).value=result['data'][i]['concession'];
							 }
							}
							
							
						 }, 500);
					} else {
						this.setState({
							fees_data_list: [],
							instl_1:0,
							instl_2:0,
							instl_3:0,
							instl_4:0,
							instl_5:0,
							instl_6:0,
							instl_7:0,
							instl_8:0,
							instl_9:0,
							instl_10:0,
							instl_11:0,
							instl_12:0,
							concession:0
						});
					}
				}
			}); 
		  
		 
     }
	 
	 
	
		
	handleSubmit=(e)=>{
		e.preventDefault();
		if(localStorage.getItem('schoolData')){
		
		
			if (this.state.academic_year == '') {
				message.config({ top: 150 });
				message.error('Please select academic year');
				this.setState({ loading: false });
			}
			else if (this.state.fees_package_id == '') {
				message.config({ top: 150 });
				message.error('Please fees package');
				this.setState({ loading: false });
			}
			else if (this.state.installment_count == '') {
				message.config({ top: 150 });
				message.error('Please select installment type');
				this.setState({ loading: false });
			}	
			else {
		
			this.setState({ loading: true });
			var storedArray = JSON.parse(localStorage.getItem("schoolData"))


				var category_id = [];
				var category_name = [];
				var category_amount = [];
				var one_time_concession = [];			
				var instl = [];
				var product = [];

				var form_count = document.getElementsByName('category_id[]');


				for (var i = 0; i < form_count.length; i++) {
					category_id[i] = document.getElementsByName('category_id[]')[i].value;
					category_name[i] = document.getElementsByName('category_name[]')[i].value;
					category_amount[i] = document.getElementsByName('category_amount[]')[i].value;
					one_time_concession[i] = document.getElementsByName('one_time_concession[]')[i].value;
				
					var instl_list = new Array();
					var instl_count = this.state.installment_count;

					for (var j = 0; j < instl_count; j++) {
						var val_1 = document.getElementsByName('instl_' + i + '[]')[j].value;
						instl_list.push({
							instl: val_1,
						});
					}
					instl[i] = instl_list;
				 }
				
			
			var app = {
				school_id : storedArray['data'][0]['school_id'],
				user_id : storedArray['data'][0]['user_id'],
				academic_year : this.state.academic_year,
				fees_package_id : this.state.fees_package_id,
				installment_count : this.state.installment_count,
				type:'Optional',
				category_id:category_id,
				category_name:category_name,
				category_amount:category_amount,
				one_time_concession:one_time_concession,
				instl:instl,
			}
			getData('fees/add_fees_installment',app).then((result) => {
				if(result.status==400){
					message.config({ top: 150});
					message.error('Please select receipt to print',2);
					this.setState({ loading: false });
				}
				if(result.status==200){
					message.config({ top: 150});
					message.success('Print Setting Updated',2);
					this.setState({ loading: false });
					window.location.href = '/settings/fees/category-installment-optional';
				}
		  });
	   }
	  }
	  else{
			message.error('Please Login',2);	
	  }

  }

	
	handleRadioChange = (e) => {
		this.setState({ receipt_to_print: e });
	}
	 

	render() {

		return (
			<div class="mobile_view">
				<div id="main" class="bg-off">
					<div class="row">
						<div class="col col-md-12  ex-padd">
							<div id="breadcrumbs-wrapper" class="bg-off">
							   <div>
								  <div class="row no-margin">
									  <div class="col col-md-12  header-title mt-20 mh-40 iq-card">
										  <div class="col s12 m6 l6 pt-10 pb-15 ">
												<h5 class="breadcrumbs-title"><span class="back_arrow" onClick={this.context.router.history.goBack}><i class="ri-arrow-left-circle-line"></i></span><span class="main_title">Category Installment Structure</span></h5>
											 </div>
											 
											 <div class="col s12 m6 l6 right-align-md pt-10">
												<ol class="breadcrumbs mb-0">
												   <li class="breadcrumb-item"><a href="/">Home</a></li>
												   <li class="breadcrumb-item"><a href="/settings/fees">Fees Setting</a></li>
												   <li class="breadcrumb-item active">Category Installment Structure</li>
												</ol>
											 </div>  
										 </div>
									  </div>
							   </div>
							</div>
						</div>
						<div class="col col-md-12  ex-padd enquiry bg-off">
							<div class="container">
								<section class="invoice-list-wrapper  section">
									<div class="responsive-table iq-card bg-shadow-none">
										<ul class="nav nav-tabs" role="tablist">
											<li class="nav-item">
												<Link to={`${process.env.PUBLIC_URL}/settings/fees/category-installment-structure`} class="nav-link">Mandatory</Link>
											</li>
											<li class="nav-item">
												<Link to={`${process.env.PUBLIC_URL}/settings/fees/category-installment-optional`} class="nav-link active">Optional</Link>
											</li>
											<li class="nav-item">
												<Link to={`${process.env.PUBLIC_URL}/settings/fees/category-installment-others`} class="nav-link">Others</Link>
											</li>
										</ul>
									</div>
								</section>
								<div class="col col-md-12  card-content iq-card view-Profile imb0">
									<section class="invoice-list-wrapper section receipt">
										<div class="col m12 s12 pl-0">
											<div class="col m4 s12 pb-20">
													<label>Academic Year</label>
													<Select onChange={this.change_year}>
										 <Select.Option value="2022-2023">2022-2023</Select.Option>	
										 <Select.Option value="2021-2022">2021-2022</Select.Option>	
										 <Select.Option value="2020-2021">2020-2021</Select.Option>
										 <Select.Option value="2019-2020">2019-2020</Select.Option>
										 <Select.Option value="2018-2019">2018-2019</Select.Option>
													</Select>
											</div>
											<div class="col m4 s12 pb-20">
													<label>Fees Package:</label>
													{this.state.package_list.map((list)=>(
													<Select onChange={this.change_fees} defaultValue={this.state.fees_package_id}>
														<Select.Option value={list.id}>{list.package_name}</Select.Option>
													</Select>
													))}
											</div>
											<div class="col m4 s12 pb-20">
													<label>Select Installment Type:</label>
													{(() => {
													 if(this.state.package_list.length>0){
														 return (
															<>
															<Select onChange={this.change_installment} defaultValue={this.state.installment_count}>
																	<Select.Option value="1">Annually</Select.Option>
																	<Select.Option value="2">Half Yearly</Select.Option>
																	<Select.Option value="4">Quarterly </Select.Option>
																	<Select.Option value="12">Monthly </Select.Option>
															</Select>
															</>
														 )
													 }
													 })()}
											</div>
										</div>
										
										
										
										
										
										
									</section>
								</div>
						

					<div class="row">
						<div class="col col-md-12">						
						<div class="view-Profile receipt">
						<table class="cust_table">
						  <thead>
							<tr>
								
								<th>#</th>
								<th class="text-left">Category</th>
								<th>Amount</th>
								{this.state.installment_list.map((list,index)=> (
									<th class="text-left">Installment {list.sr_no}</th>
								))}	
								<th class="text-left">OneTime Concession</th>
							</tr>
						  </thead>

						  <tbody>
							{this.state.category_list.map((list,index)=> (
								<tr>
									<td class="text-left">{list.index}
									<input type="hidden" name="category_id[]" defaultValue={list.category_id}/>
									</td>
									<td class="text-left">{list.category_name}
									<input type="hidden" name="category_name[]" defaultValue={list.category_name}/></td>
									
									<td>{list.category_amount}
									<input type="hidden" name="category_amount[]" defaultValue={list.category_amount}/></td>
									{this.state.installment_list.map((list2,index2)=> (
										<td>
											<input id={`instl_${index}_${index2+1}`} class="installment_input" type="number" step="any" name={`instl_${index}[]`} size="15" defaultValue=""/>
										</td>
									))}	
									<td><input  class="installment_input" type="number" step="any" id={`concession_${index}`} name="one_time_concession[]" size="15" defaultValue=""/></td>
								</tr> 
							))}	
								
										
										
									  </tbody>
									</table>
				</div></div></div>
								
										
					<div class="col m12 s12 meal  mb-20 center">
		 <Button className="snd-btn btn-lg large-btn" onClick={this.handleSubmit} loading={this.state.loading}>Update</Button>
	</div>
								
					
							</div>
						</div>
           
					</div>
				</div>
			</div>
		) 
	} 
}
export default Index;
